var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "caseItem" }, [
        _vm.showAbLeft
          ? _c(
              "div",
              {
                staticClass: "caseItem-absolute-left",
                on: { click: _vm.onShowCaseLeft },
              },
              [
                _c("img", {
                  attrs: {
                    src: require("../../assets/images/help_fill.png"),
                    alt: "",
                  },
                }),
              ]
            )
          : _vm._e(),
        _c(
          "div",
          {
            staticClass: "caseItem-search",
            on: { click: _vm.onShowCaseDetail },
          },
          [_c("i", { staticClass: "el-icon-search" })]
        ),
        _c(
          "div",
          { staticClass: "caseItem-item", on: { click: _vm.onCaseDetail } },
          [
            _vm.caseItem.casePic
              ? _c(
                  "div",
                  { staticClass: "caseItem-casePic flex flex-center-1" },
                  [
                    _c("el-image", {
                      attrs: {
                        src: _vm.$imgfilter(_vm.caseItem.casePic),
                        fit: "contain",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm.caseItem.itemPic
              ? _c(
                  "div",
                  { staticClass: "caseItem-itemPic flex flex-center-1" },
                  [
                    _c("el-image", {
                      attrs: {
                        src: _vm.$imgfilter(_vm.caseItem.itemPic),
                        fit: "contain",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "div",
              { staticClass: "caseItem-info flex flex-col flex-center-1" },
              [
                _c("p", { staticClass: "title" }, [
                  _vm._v(_vm._s(_vm.caseItem.caseName)),
                ]),
                _vm.showCreatorName && _vm.caseItem.creatorName
                  ? _c("p", { staticClass: "creator-name" }, [
                      _vm._v(" " + _vm._s(_vm.caseItem.creatorName) + " "),
                    ])
                  : _vm._e(),
                _vm.showPrice
                  ? _c(
                      "div",
                      { staticClass: "userInfo-price-item flex flex-ver" },
                      [
                        _c("p", { staticClass: "userInfo-price-p" }, [
                          _vm._v(
                            " " +
                              _vm._s(_vm._f("conversion")(_vm.displayPrice)) +
                              " "
                          ),
                          _vm.isUsingHappyCoin
                            ? _c(
                                "span",
                                { staticStyle: { "font-size": "12px" } },
                                [_vm._v("欢乐豆")]
                              )
                            : _vm._e(),
                        ]),
                      ]
                    )
                  : _vm._e(),
                _vm.showfubencishu && _vm.showfubencishu == "show"
                  ? _c(
                      "div",
                      { staticClass: "userInfo-price-item-1 flex flex-ver" },
                      [
                        _c("p", { staticClass: "userInfo-price-p" }, [
                          _vm._v(
                            " " +
                              _vm._s(_vm.caseItem.accumulateCaseRoundCount) +
                              " / " +
                              _vm._s(_vm.caseItem.accumulateCaseRate) +
                              " "
                          ),
                        ]),
                      ]
                    )
                  : _vm._e(),
                _vm.showfubencishu && _vm.showfubencishu == "zhanwei"
                  ? _c("div", {
                      staticClass: "userInfo-price-item-1 flex flex-ver",
                    })
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "caseItem-info-risk flex flex-ver" },
                  [
                    _vm._l(_vm.riskList, function (riskItem, rishIndex) {
                      return _c(
                        "div",
                        {
                          key: rishIndex,
                          staticClass:
                            "caseItem-info-risk-item flex flex-col flex-center-1",
                        },
                        [
                          _c("div", {
                            staticClass: "schedule",
                            style: {
                              "background-color":
                                _vm.currentRisk == riskItem.value
                                  ? riskItem.activeBg
                                  : "rgba(255, 255, 255, 0.2)",
                            },
                          }),
                          _c(
                            "p",
                            {
                              staticClass: "risk-p",
                              class: {
                                rishPActive: _vm.currentRisk == riskItem.value,
                              },
                            },
                            [_vm._v(" " + _vm._s(riskItem.name) + " ")]
                          ),
                        ]
                      )
                    }),
                    _c("div", {
                      staticClass: "current-risk-schedule",
                      style: {
                        left: _vm.currentRiskSchedule + "%",
                      },
                    }),
                  ],
                  2
                ),
              ]
            ),
          ]
        ),
      ]),
      _c(
        "Modal",
        {
          attrs: {
            "class-name": "app-modal caseItemModelItem",
            "footer-hide": "",
            closable: false,
            width: "'700rem'",
          },
          model: {
            value: _vm.is_case_item_modal_show,
            callback: function ($$v) {
              _vm.is_case_item_modal_show = $$v
            },
            expression: "is_case_item_modal_show",
          },
        },
        [
          _c(
            "c-interactive-panel",
            {
              attrs: { title: "所含饰品", has_close_button: "" },
              on: {
                close_button_click: function ($event) {
                  _vm.is_case_item_modal_show = false
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "caseItemModelItem-item" },
                _vm._l(_vm.case_awards, function (item, award_index) {
                  return _c("c-award", {
                    key: award_index,
                    staticClass: "case_awards_item",
                    attrs: {
                      rarity: item.rarity,
                      picture: item.itempic,
                      name: item.itemname,
                      price: item.price,
                      rate: item.viewRate,
                      width: "100%",
                    },
                  })
                }),
                1
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }